import {DEFAULT_PHRASES_COUNT, FILTER_TYPE_CHECKBOX} from "../constant";
import { PHRASE_URL_PART, PREFERENCE_URL, getFetchRequest, postFetchRequest } from "../store/requests";
import {errorCallback, makeUrl, successCallbackEmpty} from "../util";
import {createListOfFilters} from "./preferenceUtil";
import defaultI18n from "../i18nService";

export const BASED_ON_PHRASE = 'phrase';

const createQueryParams = (lastPhraseId, offset, isWelcome, searchValue, sortingDirection, filtersList) => {
    let result = '/?';
    offset ? result += `count=${offset}` : '';
    offset && lastPhraseId ? result += '&' : '';
    lastPhraseId ? result += `lastId=${lastPhraseId}` : '';
    sortingDirection ? result += `&sorting=vote:${sortingDirection},dateCreated:desc` : result += '&sorting=dateCreated:desc';
    isWelcome ? result += '&welcome=true' : '';
    searchValue ? result += `&phraseContent=${searchValue}` : '';
    if(filtersList.length) {
        result += '&filtering=';
        filtersList.forEach(filter => {
            result += `${filter.filterGroupName}:${filter.filterName.split('.')[1]},`;
        });
        result = result.slice(0, -1);
    }
    return result;
};

export const preferencesPhrasesStorage = {
    basedOn: BASED_ON_PHRASE,
    preferencesPhrases: [],
    preferenceId: '',
    selectedItems: [],
    sortingDirection: '',
    observersList: [],
    isWelcome: false,
    searchValue: '',
    possibleFilters: [],
    filtersList: [],
    pageSize: DEFAULT_PHRASES_COUNT,
    setPageSize(size) {
        this.pageSize = size || DEFAULT_PHRASES_COUNT;
    },
    setInitialFilters(searchParams, callback) {
        const filtersList = [];
        searchParams.forEach((value, key) => {
            const currentFilter = this.possibleFilters.find(it => it.filterName === key);
            if(currentFilter.filterType === FILTER_TYPE_CHECKBOX && value === 'true') {
                currentFilter.value = value;
                filtersList.push(currentFilter);
            }
        });
        this.filtersList = filtersList;
        callback && callback();
    },
    loadNextPhrases(lastPhraseId, offset, callback, i18n = defaultI18n) {
        try {
            const preparedRequestPath = makeUrl([
                PREFERENCE_URL, 
                this.basedOn === BASED_ON_PHRASE ? i18n.resolvedLanguage : this.preferenceId ,
                this.basedOn === BASED_ON_PHRASE ? 
                    createQueryParams(lastPhraseId, offset, this.isWelcome, this.searchValue, this.sortingDirection, this.filtersList)
                    : 
                    PHRASE_URL_PART,
            ]);
            getFetchRequest(preparedRequestPath, (response) => {
                this.preferencesPhrases = lastPhraseId ? [...this.preferencesPhrases, ...response] : response;
                callback(response);
                this.notifyFiltersChangingObservers();
            }, errorCallback);
        } catch(err) {
            console.log(err);
        }
    },
    getPhrases() {
        return this.preferencesPhrases;
    },
    removePhrase(phraseId) {
        this.preferencesPhrases = this.preferencesPhrases.filter(it => it.id !== phraseId);
    },
    getSelectedList() {
        return this.selectedItems;
    },
    changeSelectedPhrasesList(phraseId, cleanAll = false) {
        console.log("--------------------------------changeSelectedPhrasesList-");
        console.log(this.selectedItems);
        if(phraseId) {
            if(this.selectedItems.find(it => it.id === phraseId)) {
                this.selectedItems = this.selectedItems.filter(it => it.id !== phraseId);
            } else {
                this.selectedItems.push(this.preferencesPhrases.find(it => it.id === phraseId));
            }
        } else {
            if((this.preferencesPhrases.length === this.selectedItems.length && this.selectedItems.length !== 0) || cleanAll) {
                this.selectedItems = []; 
            } else {
                this.selectedItems = this.preferencesPhrases;
            }
        }
        this.notifyFiltersChangingObservers();
    },
    getSortingDirection() {
        return this.sortingDirection;
    },
    changeSortingDirection(sortingDirection) {
        this.sortingDirection = sortingDirection;
        this.loadNextPhrases('', this.pageSize, () => {});
    },
    cleanStorage() {
        this.basedOn = BASED_ON_PHRASE;
        this.preferencesPhrases = [];
        this.preferenceId = '';
        this.selectedItems = [];
        this.sortingDirection = '';
        this.isWelcome = false;
        this.searchValue = '';
        this.possibleFilters = [];
        this.filtersList = [];
        this.pageSize = DEFAULT_PHRASES_COUNT;
    },
    registerFiltersChangingObserver(observer) {
        this.observersList.push(observer);
    },
    unRegisterFiltersChangingObserver(observer) {
        this.observersList = this.observersList.filter(observerItem => observerItem !== observer);
    },
    notifyFiltersChangingObservers() {
        this.observersList.forEach(observer => {
            observer();
        });
    },
    getById(phraseId) {
        return this.preferencesPhrases.find(it => it.id === phraseId);
    },
    changeFiltersList(filterKey, filterValue) {
        this[filterKey] = filterValue;
        this.loadNextPhrases('', this.pageSize, () => {});
    },
    setSearchString(searchStringValue) {
        this.searchValue = searchStringValue;
        this.loadNextPhrases('', this.pageSize, () => {});
    },
    getSearchString() {
        return this.searchValue;
    },
    setCheckedFilterValue(filterName, selectedKeys) {
        const currentFilter = this.filtersList.find(it => it.filterName === filterName);
        if(currentFilter) {
            currentFilter.value = selectedKeys;
        } else {
            const possibleFilter = this.possibleFilters.find(it => it.filterName === filterName);
            possibleFilter.value = selectedKeys;
            this.filtersList.push(possibleFilter);
        }
        this.filtersList = this.filtersList.filter(it =>
            it.filterType !== FILTER_TYPE_CHECKBOX || (it.filterType === FILTER_TYPE_CHECKBOX && it.value == true));
    },
    getPossibleFilters() {
        this.possibleFilters = createListOfFilters();
        return this.possibleFilters;
    },
    getCurrentFilters() {
        return this.filtersList;
    },
    getAnyFiltersByGroup(groupName) {
        return this.possibleFilters.find((it) => it.filterGroupName === groupName);
    },
    getCurrentFiltersByGroup(groupName) {
        return this.possibleFilters.filter(it => it.filterGroupName === groupName);
    },
    cleanFilterValues() {
        this.filtersList = [];
        this.possibleFilters.forEach((it, index) => {
            if(it.filterType === FILTER_TYPE_CHECKBOX) {
                this.possibleFilters[index].value = false;
            }
        });
        this.notifyFiltersChangingObservers();
    },
    reloadPagesNumber() {
        this.preferencesPhrases = [];
        this.loadNextPhrases('', this.pageSize, successCallbackEmpty);
    },
    changeDeletedItemsView() {
    },
    changeValidItemsView() {
    },
    updatePreferenceIsWelcome(isWelcome, preferencePhraseId = null, i18n = defaultI18n) {
        if (preferencePhraseId !== null) {
            postFetchRequest(makeUrl([PREFERENCE_URL, i18n.resolvedLanguage, PHRASE_URL_PART, preferencePhraseId, '/']),
                {isWelcome}, successCallbackEmpty, errorCallback, true);
            this.preferencesPhrases.forEach(it => it.id === preferencePhraseId ? it.isWelcome = isWelcome : null);
        } else {
            this.selectedItems.forEach(it => {
                it.isWelcome = isWelcome;
                postFetchRequest(makeUrl([PREFERENCE_URL, i18n.resolvedLanguage, PHRASE_URL_PART, it.id, '/']),
                    {isWelcome}, successCallbackEmpty, errorCallback, true);
                this.preferencesPhrases.forEach(phrase => it.id === phrase.id ? it.isWelcome = isWelcome : null);
            });
        }
        this.notifyFiltersChangingObservers();
    },

    updatePreferenceVote(phraseId, value, i18n = defaultI18n) {
        const currentPhrase = this.preferencesPhrases.find(it => it.id === phraseId);
        currentPhrase.vote = value;
        postFetchRequest(makeUrl([PREFERENCE_URL, i18n.resolvedLanguage, PHRASE_URL_PART, phraseId, '/']), {vote: value},
            successCallbackEmpty, errorCallback, true);
        this.notifyFiltersChangingObservers();
    },
};
